import React from "react";
import PropTypes from "prop-types";

import BoolControl from "./BoolControl";
import { validateCheckOnlyModified, validateDnsOrIp, validatePort,
	validateEmail } from "./SettingsValue";
import StringControl from "./StringControl";

const EmailAccount = props => (
	<form>
		<StringControl i18n_key="SMTP server" prop="smtp_server"
			validate={validateDnsOrIp} local={props.account} handleChange={props.handleChange} />
		<StringControl i18n_key="SMTP port number" prop="smtp_port"
			validate={validatePort} local={props.account} handleChange={props.handleChange} />
		<StringControl i18n_key="User name" prop="user_name"
			validate={validateCheckOnlyModified} local={props.account} handleChange={props.handleChange} />
		<StringControl i18n_key="Password" prop="user_password"
			validate={validateCheckOnlyModified} local={props.account} handleChange={props.handleChange} />
		<StringControl i18n_key="Sender address" prop="sender_address"
			validate={validateEmail} local={props.account} handleChange={props.handleChange} />
		<BoolControl i18n_key="Use StartTLS" prop="use_starttls"
			local={props.account} handleChange={props.handleChange} />
	</form>
);

EmailAccount.propTypes = {
	account: PropTypes.object.isRequired,
	handleChange: PropTypes.func.isRequired
};

export default EmailAccount;
